// Tijden van de opbouw naar de record-stempel, gedeeld door de verkoop
// (hooks/useSaleEvents.js) en het geluid (audio/cues.js): het aanzwellen
// onder de aankondiging houdt op precies waar de stempel neerkomt.

// Dan komt de stempel neer, zie fx-stamp-slam in animations.css.
export const stampHitMs = 200;

// Begint als de klank van de aankondiging wegsterft.
export const recordBuildMs = 1800;

export const recordBuildTicks = 12;

// Wanneer tik `index` valt; de gaten worden kwadratisch kleiner.
export function recordBuildTickMs(index) {
  const part = index / recordBuildTicks;
  return Math.round(recordBuildMs * (1 - (1 - part) * (1 - part)));
}

// Het eigen record draait de aankondiging om (SaleSplash in AnimationLayer.js);
// zo lang blijft die daarna staan.
export const bestHoldMs = 7000;

// Los afgespeeld (toets 4 in het lab) staat hij er meteen als record.
export const personalBestMs = 8000;

// De balk komt vlak na het omdraaien, maar nooit voor de regels binnen zijn (1,3s).
export const beatBarAt = (flipAt) => Math.max(flipAt + 300, 1300);
